/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  CreateSecuritiesTransferResponse,
  CreateSecuritiesTransferRequest,
  GetSecuritiesTransferResponse,
  UtxSecuritiesGetSecuritiesTransferParams,
  GetSecuritiesOverviewResponse,
  GetSecuritiesBalanceSummaryResponse,
  UtxSecuritiesGetSecuritiesBalanceSummaryAsOfDateParams,
  GetSecuritiesProductSummaryResponse,
  UtxSecuritiesGetSecuritiesProductsSummaryParams,
  GetNetAssetValueHistoryResponse,
  UtxSecuritiesGetNetAssetValueHistoryParams,
  GetSecuritiesAccountResponse,
  OpenSecuritiesAccountRequest,
  GetBrokersResponse,
  GetUserSecuritiesBrokersResponse,
  UtxSecuritiesGetUserSecuritiesBrokersParams,
  GetUserSecuritiesStatementsResponse,
  UtxSecuritiesGetUserSecuritiesStatementsParams
} from './schema'



/**
 * Create securities transfer request
 */
export const utxSecuritiesCreateSecuritiesTransferRequest = (
    createSecuritiesTransferRequest: CreateSecuritiesTransferRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateSecuritiesTransferResponse>> => {
    return axios.post(
      `/securities/transfer`,
      createSecuritiesTransferRequest,options
    );
  }



    export type UtxSecuritiesCreateSecuritiesTransferRequestMutationResult = NonNullable<Awaited<ReturnType<typeof utxSecuritiesCreateSecuritiesTransferRequest>>>
    export type UtxSecuritiesCreateSecuritiesTransferRequestMutationBody = CreateSecuritiesTransferRequest
    export type UtxSecuritiesCreateSecuritiesTransferRequestMutationError = AxiosError<unknown>

    export const useUtxSecuritiesCreateSecuritiesTransferRequest = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxSecuritiesCreateSecuritiesTransferRequest>>, TError,{data: CreateSecuritiesTransferRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxSecuritiesCreateSecuritiesTransferRequest>>, {data: CreateSecuritiesTransferRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxSecuritiesCreateSecuritiesTransferRequest(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxSecuritiesCreateSecuritiesTransferRequest>>, TError, {data: CreateSecuritiesTransferRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Get securities transfer
 */
export const utxSecuritiesGetSecuritiesTransfer = (
    params?: UtxSecuritiesGetSecuritiesTransferParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetSecuritiesTransferResponse>> => {
    return axios.get(
      `/securities/transfer`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxSecuritiesGetSecuritiesTransferQueryKey = (params?: UtxSecuritiesGetSecuritiesTransferParams,) => [`/securities/transfer`, ...(params ? [params]: [])];

    
export type UtxSecuritiesGetSecuritiesTransferQueryResult = NonNullable<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesTransfer>>>
export type UtxSecuritiesGetSecuritiesTransferQueryError = AxiosError<unknown>

export const useUtxSecuritiesGetSecuritiesTransfer = <TData = Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesTransfer>>, TError = AxiosError<unknown>>(
 params?: UtxSecuritiesGetSecuritiesTransferParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesTransfer>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxSecuritiesGetSecuritiesTransferQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesTransfer>>> = ({ signal }) => utxSecuritiesGetSecuritiesTransfer(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesTransfer>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Returns securities overview
 */
export const utxSecuritiesGetSecuritiesOverview = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetSecuritiesOverviewResponse>> => {
    return axios.get(
      `/securities/summary`,options
    );
  }


export const getUtxSecuritiesGetSecuritiesOverviewQueryKey = () => [`/securities/summary`];

    
export type UtxSecuritiesGetSecuritiesOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesOverview>>>
export type UtxSecuritiesGetSecuritiesOverviewQueryError = AxiosError<unknown>

export const useUtxSecuritiesGetSecuritiesOverview = <TData = Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesOverview>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesOverview>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxSecuritiesGetSecuritiesOverviewQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesOverview>>> = ({ signal }) => utxSecuritiesGetSecuritiesOverview({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesOverview>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Returns securities balance summary
 */
export const utxSecuritiesGetSecuritiesBalanceSummaryAsOfDate = (
    params?: UtxSecuritiesGetSecuritiesBalanceSummaryAsOfDateParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetSecuritiesBalanceSummaryResponse>> => {
    return axios.get(
      `/securities/summary/balance`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxSecuritiesGetSecuritiesBalanceSummaryAsOfDateQueryKey = (params?: UtxSecuritiesGetSecuritiesBalanceSummaryAsOfDateParams,) => [`/securities/summary/balance`, ...(params ? [params]: [])];

    
export type UtxSecuritiesGetSecuritiesBalanceSummaryAsOfDateQueryResult = NonNullable<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesBalanceSummaryAsOfDate>>>
export type UtxSecuritiesGetSecuritiesBalanceSummaryAsOfDateQueryError = AxiosError<unknown>

export const useUtxSecuritiesGetSecuritiesBalanceSummaryAsOfDate = <TData = Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesBalanceSummaryAsOfDate>>, TError = AxiosError<unknown>>(
 params?: UtxSecuritiesGetSecuritiesBalanceSummaryAsOfDateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesBalanceSummaryAsOfDate>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxSecuritiesGetSecuritiesBalanceSummaryAsOfDateQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesBalanceSummaryAsOfDate>>> = ({ signal }) => utxSecuritiesGetSecuritiesBalanceSummaryAsOfDate(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesBalanceSummaryAsOfDate>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Returns securities product summary
 */
export const utxSecuritiesGetSecuritiesProductsSummary = (
    params?: UtxSecuritiesGetSecuritiesProductsSummaryParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetSecuritiesProductSummaryResponse>> => {
    return axios.get(
      `/securities/summary/product`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxSecuritiesGetSecuritiesProductsSummaryQueryKey = (params?: UtxSecuritiesGetSecuritiesProductsSummaryParams,) => [`/securities/summary/product`, ...(params ? [params]: [])];

    
export type UtxSecuritiesGetSecuritiesProductsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesProductsSummary>>>
export type UtxSecuritiesGetSecuritiesProductsSummaryQueryError = AxiosError<unknown>

export const useUtxSecuritiesGetSecuritiesProductsSummary = <TData = Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesProductsSummary>>, TError = AxiosError<unknown>>(
 params?: UtxSecuritiesGetSecuritiesProductsSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesProductsSummary>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxSecuritiesGetSecuritiesProductsSummaryQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesProductsSummary>>> = ({ signal }) => utxSecuritiesGetSecuritiesProductsSummary(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesProductsSummary>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Return net asset value history
 */
export const utxSecuritiesGetNetAssetValueHistory = (
    params: UtxSecuritiesGetNetAssetValueHistoryParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetNetAssetValueHistoryResponse[]>> => {
    return axios.get(
      `/securities/history`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxSecuritiesGetNetAssetValueHistoryQueryKey = (params: UtxSecuritiesGetNetAssetValueHistoryParams,) => [`/securities/history`, ...(params ? [params]: [])];

    
export type UtxSecuritiesGetNetAssetValueHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof utxSecuritiesGetNetAssetValueHistory>>>
export type UtxSecuritiesGetNetAssetValueHistoryQueryError = AxiosError<unknown>

export const useUtxSecuritiesGetNetAssetValueHistory = <TData = Awaited<ReturnType<typeof utxSecuritiesGetNetAssetValueHistory>>, TError = AxiosError<unknown>>(
 params: UtxSecuritiesGetNetAssetValueHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxSecuritiesGetNetAssetValueHistory>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxSecuritiesGetNetAssetValueHistoryQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxSecuritiesGetNetAssetValueHistory>>> = ({ signal }) => utxSecuritiesGetNetAssetValueHistory(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxSecuritiesGetNetAssetValueHistory>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Returns list of brokerage accounts
 */
export const utxSecuritiesGetSecuritiesAccounts = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetSecuritiesAccountResponse>> => {
    return axios.get(
      `/securities/accounts`,options
    );
  }


export const getUtxSecuritiesGetSecuritiesAccountsQueryKey = () => [`/securities/accounts`];

    
export type UtxSecuritiesGetSecuritiesAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesAccounts>>>
export type UtxSecuritiesGetSecuritiesAccountsQueryError = AxiosError<unknown>

export const useUtxSecuritiesGetSecuritiesAccounts = <TData = Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesAccounts>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesAccounts>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxSecuritiesGetSecuritiesAccountsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesAccounts>>> = ({ signal }) => utxSecuritiesGetSecuritiesAccounts({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxSecuritiesGetSecuritiesAccounts>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Request to open securities account
 */
export const utxSecuritiesOpenSecuritiesAccount = (
    openSecuritiesAccountRequest: OpenSecuritiesAccountRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/securities/open-account`,
      openSecuritiesAccountRequest,options
    );
  }



    export type UtxSecuritiesOpenSecuritiesAccountMutationResult = NonNullable<Awaited<ReturnType<typeof utxSecuritiesOpenSecuritiesAccount>>>
    export type UtxSecuritiesOpenSecuritiesAccountMutationBody = OpenSecuritiesAccountRequest
    export type UtxSecuritiesOpenSecuritiesAccountMutationError = AxiosError<unknown>

    export const useUtxSecuritiesOpenSecuritiesAccount = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxSecuritiesOpenSecuritiesAccount>>, TError,{data: OpenSecuritiesAccountRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxSecuritiesOpenSecuritiesAccount>>, {data: OpenSecuritiesAccountRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxSecuritiesOpenSecuritiesAccount(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxSecuritiesOpenSecuritiesAccount>>, TError, {data: OpenSecuritiesAccountRequest}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Returns list of brokers
 */
export const utxSecuritiesGetBrokers = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetBrokersResponse[]>> => {
    return axios.get(
      `/securities/brokers`,options
    );
  }


export const getUtxSecuritiesGetBrokersQueryKey = () => [`/securities/brokers`];

    
export type UtxSecuritiesGetBrokersQueryResult = NonNullable<Awaited<ReturnType<typeof utxSecuritiesGetBrokers>>>
export type UtxSecuritiesGetBrokersQueryError = AxiosError<unknown>

export const useUtxSecuritiesGetBrokers = <TData = Awaited<ReturnType<typeof utxSecuritiesGetBrokers>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxSecuritiesGetBrokers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxSecuritiesGetBrokersQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxSecuritiesGetBrokers>>> = ({ signal }) => utxSecuritiesGetBrokers({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxSecuritiesGetBrokers>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Returns list of user brokers
 */
export const utxSecuritiesGetUserSecuritiesBrokers = (
    params?: UtxSecuritiesGetUserSecuritiesBrokersParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserSecuritiesBrokersResponse>> => {
    return axios.get(
      `/securities/user-brokers`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxSecuritiesGetUserSecuritiesBrokersQueryKey = (params?: UtxSecuritiesGetUserSecuritiesBrokersParams,) => [`/securities/user-brokers`, ...(params ? [params]: [])];

    
export type UtxSecuritiesGetUserSecuritiesBrokersQueryResult = NonNullable<Awaited<ReturnType<typeof utxSecuritiesGetUserSecuritiesBrokers>>>
export type UtxSecuritiesGetUserSecuritiesBrokersQueryError = AxiosError<unknown>

export const useUtxSecuritiesGetUserSecuritiesBrokers = <TData = Awaited<ReturnType<typeof utxSecuritiesGetUserSecuritiesBrokers>>, TError = AxiosError<unknown>>(
 params?: UtxSecuritiesGetUserSecuritiesBrokersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxSecuritiesGetUserSecuritiesBrokers>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxSecuritiesGetUserSecuritiesBrokersQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxSecuritiesGetUserSecuritiesBrokers>>> = ({ signal }) => utxSecuritiesGetUserSecuritiesBrokers(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxSecuritiesGetUserSecuritiesBrokers>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxSecuritiesGetUserSecuritiesStatements = (
    params: UtxSecuritiesGetUserSecuritiesStatementsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetUserSecuritiesStatementsResponse>> => {
    return axios.get(
      `/securities/statements`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getUtxSecuritiesGetUserSecuritiesStatementsQueryKey = (params: UtxSecuritiesGetUserSecuritiesStatementsParams,) => [`/securities/statements`, ...(params ? [params]: [])];

    
export type UtxSecuritiesGetUserSecuritiesStatementsQueryResult = NonNullable<Awaited<ReturnType<typeof utxSecuritiesGetUserSecuritiesStatements>>>
export type UtxSecuritiesGetUserSecuritiesStatementsQueryError = AxiosError<unknown>

export const useUtxSecuritiesGetUserSecuritiesStatements = <TData = Awaited<ReturnType<typeof utxSecuritiesGetUserSecuritiesStatements>>, TError = AxiosError<unknown>>(
 params: UtxSecuritiesGetUserSecuritiesStatementsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxSecuritiesGetUserSecuritiesStatements>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxSecuritiesGetUserSecuritiesStatementsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxSecuritiesGetUserSecuritiesStatements>>> = ({ signal }) => utxSecuritiesGetUserSecuritiesStatements(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxSecuritiesGetUserSecuritiesStatements>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxSecuritiesCatsSignin = (
    theme: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/securities/cats/signin/${theme}`,undefined,options
    );
  }



    export type UtxSecuritiesCatsSigninMutationResult = NonNullable<Awaited<ReturnType<typeof utxSecuritiesCatsSignin>>>
    
    export type UtxSecuritiesCatsSigninMutationError = AxiosError<unknown>

    export const useUtxSecuritiesCatsSignin = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxSecuritiesCatsSignin>>, TError,{theme: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxSecuritiesCatsSignin>>, {theme: string}> = (props) => {
          const {theme} = props ?? {};

          return  utxSecuritiesCatsSignin(theme,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxSecuritiesCatsSignin>>, TError, {theme: string}, TContext>(mutationFn, mutationOptions)
    }
    